export default function DropdownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        cx="12"
        cy="12.0005"
        r="8.25"
        stroke="#455468"
        strokeWidth="1.5"
      />
      <path
        d="M15 11.0005L12 14.0005L9 11.0005"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
